exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".period {\n  float: left;\n  clear: both;\n  overflow: hidden;\n  margin: 1em 0 0;\n  margin-top: 1.5em; }\n  .period .daily {\n    padding-top: .1em;\n    margin-bottom: 1em; }\n  .period .day-of-week {\n    margin-top: .3em;\n    float: left; }\n  .period .errors {\n    margin-top: .8em;\n    min-height: 1.2em;\n    float: left;\n    clear: both;\n    color: #d60300;\n    font-size: .9em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/DaysOfWeekComponent/daysOfWeek.component.scss
// module id = ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/DaysOfWeekComponent/daysOfWeek.component.scss
// module chunks = main